
import moment, { type Moment } from 'moment';
import { BaseFilter } from '..';
import Contact from './contact';

export default class ContactFilter extends BaseFilter<Contact> {
    constructor(filter?: Partial<ContactFilter>) {
        super();
        if (filter) this.update(filter);
    }

    id?: string;
    schoolId?: string;
    email?: string;
    moderateForumThreadId: string | null;
    similarChatUserId: string;
    createdDateFrom: Moment | null = null;
    createdDateTo: Moment | null = null;

    update(changes: Partial<ContactFilter>) {
        super.update(changes);
        if (changes.createdDateFrom !== undefined)
            this.createdDateFrom = changes.createdDateFrom ? moment(changes.createdDateFrom) : null;
        if (changes.createdDateTo !== undefined)
            this.createdDateTo = changes.createdDateTo ? moment(changes.createdDateTo) : null;
    }

    static fromJson(filter: any) {
        return new ContactFilter({
            ...filter,
            createdDateFrom: filter?.createdDateFrom ? moment(filter.createdDateFrom) : null,
            createdDateTo: filter?.createdDateTo ? moment(filter.createdDateTo) : null,
        });
    }
}
